module.exports = __webpack_public_path__ + "static/media/dokumente-vorlagen.07f65338.svg";